import {
  StyleRulesCallback,
  WithStyles,
  withStyles
} from "@material-ui/core/styles";
import * as React from "react";
import { Testing } from "shared/testing/Testing";
import Colors from "../../../../assets/Colors";
import {formStores} from "../../../Forms/state/mobx";

interface IProps {
  className?: string;
  InputProps?: any;
  onSendClicked: () => void;
  sendEnabled: boolean;
  autoFocus?: boolean;
  navigationProperty?: string;
  inputLabel: string
}

const styles: StyleRulesCallback = ({ palette, spacing, breakpoints }) => ({
  container: {
    width: "100%"
  },
  inputContainer: {
    borderWidth: 0,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: ".3em"
  },
  input: {
    border: 0,
    padding: "0 .8em",
    height: "2.9em",
    width: "100%",
    fontSize: 15,
    borderRadius: 10,
    boxShadow: "0 2px 4px 0 rgba(226, 230, 236, 0.5)",
    marginTop: ".5em",
    borderBottom: "2px solid transparent",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "&:focus": {
      outline: "none",
      borderBottom: "2px solid" + Colors.colHeaderBlue,
    },
    "&::placeholder": {
      color: "#9ca6ad",
      fontSize: 11,
      fontWeight: 200
    }
  },
  autocompleteContainer: {
    left: 0,
    top: "100%",
    width: "100%",
    position: "absolute"
  },
  send: {
    color: palette.common.black
  },
  title: {
    fontSize: 13,
    fontWeight: 400,
    color: "#9ca6ad",
    width: "100%",
    textAlign: "initial",
    [breakpoints.down(350)]: {
      fontSize: 16
    }
  },
  subtitle: {
    fontSize: 12,
    marginTop: spacing.unit,
    alignSelf: "flex-end",
    [breakpoints.down("sm")]: {
      display: "none"
    }
  }
});

const store = formStores.formStore;

@(withStyles(styles) as any)
export default class PlacesAutoCompeteInput extends React.Component<
  IProps & Partial<WithStyles<any>>
> {

  public placeInputChange = (e: any) => {
    const {navigationProperty} = this.props;
      if(e.target.value.length > 0 && navigationProperty) {
        store.setWorkspaceError(false);
        store.navigationController[navigationProperty] = true;
      }else if(e.target.value.length === 0 && navigationProperty) {
        store.navigationController[navigationProperty] = false;
      }
    };

  public render() {
    const {
      classes,
      InputProps,
      className,
        autoFocus,
      inputLabel
    } = this.props;
    return (
      <div className={[classes!.container, className].join(" ")}>
        <div className={classes!.title}>{inputLabel}</div>
        <div className={classes!.inputContainer}>
          <input
              onKeyUp={this.placeInputChange}
              className={classes!.input}
              {...InputProps}
              autoFocus={autoFocus}
              id={Testing.ids.placesAutocomplete.input}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Bots/Common/PlacesAutoComplete/PlacesAutoCompleteInput.tsx